import Seat from '../../../Seat/Seat'
import './TicketSeat.scss'

const TicketSeat = ({ seat }) => {
    const { type, label } = seat

    const withIcon = ['wheelchair', 'positionable', 'vip'].includes(type)

    return (
        <div className={'ticket-seat-part'}>
            {withIcon && <Seat className={'ticket-seat'} type={type} disabled />}
            <span className={'ticket-seat-label'}>{label}</span>
        </div>
    )
}

export default TicketSeat
